import { useQuery } from '@tanstack/react-query'

import type { ClinicId } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Lists schedule overrides for a date range (admin). Pass `clinicIds` to scope
 * to specific clinics (e.g. the active region's clinics); omit for every clinic.
 */
export function useListScheduleOverrides(opts: {
  from: string
  to: string
  clinicIds?: ClinicId[]
}) {
  const api = useOsApi()
  const { from, to, clinicIds } = opts

  return useQuery({
    queryKey: ['admin', 'schedule-overrides', from, to, clinicIds ?? 'all'],
    queryFn: async () => {
      const response = await api.get('/schedules/overrides', { query: { from, to, clinicIds } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.scheduleOverrides
    },
  })
}
